import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Section from "../Section";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import { pageTitle } from "../../helpers/PageTitle";

const serviceDetailsData = {
  ayurveda: {
    title: "Ayurveda Services",
    imgUrl: "/images/services/ayurveda.jpg",
    description:
      "Experience holistic healing through the ancient science of Ayurveda. Our treatments focus on balancing the body, mind, and spirit for long-term health and wellness.",
    services: [
      "Ayurvedic Consultation – Personalized health assessments based on body constitution (Prakriti) and lifestyle to identify imbalances and design holistic treatment plans.",
      "Panchakarma Therapy – A detoxification and rejuvenation program that includes five cleansing treatments to purify the body and restore balance.",
      "Herbal Medicine & Nutrition – Use of natural herbs, supplements, and dietary guidance to promote healing and maintain wellness.",
      "Lifestyle & Preventive Care – Tailored daily routines (Dinacharya), seasonal regimens (Ritucharya), and stress management practices for long-term health.",
      "Ayurvedic Skin & Hair Care – Natural therapies to manage acne, pigmentation, hair fall, and other dermatological concerns through herbal remedies and diet correction.",
      "Pain & Joint Management – Ayurvedic therapies like Abhyanga, Kizhi, and Basti for arthritis, back pain, and musculoskeletal issues.",
      "Women's Health & Wellness – Holistic care for menstrual disorders, menopause, fertility, and hormonal balance using traditional Ayurvedic approaches.",
    ],
  },
  "family-physician": {
    title: "Family Physician Services",
    imgUrl: "/images/services/family-physician.jpg",
    description:
      "Comprehensive medical care for all age groups — from preventive screenings to chronic disease management — ensuring every family member stays healthy.",
    services: [
      "Comprehensive Health Check-ups – Routine assessments to monitor overall health and detect early signs of illness.",
      "Chronic Disease Management – Ongoing care for conditions such as diabetes, hypertension, thyroid disorders, and asthma.",
      "Acute Illness Treatment – Diagnosis and treatment for infections, fevers, colds, allergies, and minor injuries.",
      "Preventive & Vaccination Care – Immunizations and preventive screenings for individuals and families.",
      "Geriatric Care – Health support for seniors focusing on mobility, nutrition, and chronic condition management.",
      "Pediatric Care – Regular child check-ups, growth tracking, and preventive care from infancy through adolescence.",
      "Women's & Reproductive Health – Care for menstrual health, pregnancy guidance, and hormonal issues.",
    ],
  },
  counselling: {
    title: "Counseling & Psychotherapy Services",
    imgUrl: "/images/services/counselling.jpg",
    description:
      "We provide a safe and supportive environment to help you manage emotions, relationships, and mental health challenges effectively.",
    services: [
      "Individual Counseling – One-on-one sessions addressing stress, anxiety, depression, and emotional well-being.",
      "Couples & Family Therapy – Helping partners and families improve communication, resolve conflicts, and strengthen relationships.",
      "Adolescent & Child Counseling – Supporting youth through emotional, academic, or behavioral challenges.",
      "Career & Life Coaching – Guidance for decision-making, personal growth, and professional direction.",
      "Mindfulness & Stress Management – Techniques to build emotional resilience and inner calm through relaxation and meditation.",
      "Trauma & Grief Therapy – Compassionate support to heal from loss, trauma, or major life changes.",
      "Cognitive Behavioral Therapy (CBT) – Evidence-based approach to help modify negative thought patterns and behaviors.",
    ],
  },
};

export default function ServiceDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = serviceDetailsData[slug];

  React.useEffect(() => {
    pageTitle(service ? service.title : "Service Details");
  }, [service]);

  if (!service) {
    return (
      <Section>
        <div style={{ textAlign: "center", padding: "100px 20px" }}>
          <h2>Service Not Found</h2>
          <button onClick={() => navigate("/about")}>Back to Services</button>
        </div>
      </Section>
    );
  }

  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl={service.imgUrl}
        title={service.title}
        subTitle="Detailed Overview of Our Healthcare Services"
      />

      <Section topMd={120} topLg={60} topXl={100} bottomMd={100}>
        <div style={{ padding: "0 80px" }}>
          <h2>{service.title}</h2>
          <p
            style={{
              color: "#555",
              lineHeight: "1.7",
              marginBottom: "40px",
              fontSize: "16px",
            }}
          >
            {service.description}
          </p>

          <ul
            style={{
              listStyleType: "disc",
              paddingLeft: "20px",
              color: "#444",
            }}
          >
            {service.services.map((item, index) => (
              <li
                key={index}
                style={{
                  marginBottom: "15px",
                  fontSize: "16px",
                  lineHeight: "1.6",
                }}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Section>

      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="/images/about/background.jpg"
          title="Ready to Begin Your Healing Journey?"
          subTitle="Schedule your appointment today and experience holistic wellness."
          center
        />
      </Section>
    </>
  );
}
